import { render, staticRenderFns } from "./WizardActions.vue?vue&type=template&id=329b8fe1&"
import script from "./WizardActions.vue?vue&type=script&lang=ts&"
export * from "./WizardActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports